"use strict";

exports.__esModule = true;
exports.createHost = void 0;
var _channel = require("./channel");
const createHost = function (config) {
  const clientSdk = typeof $wixContext !== 'undefined' && $wixContext.clientSdk || (config == null ? void 0 : config.clientSdk) || window.clientSdk;
  const {
    applicationId
  } = config || {};
  if (!applicationId) {
    throw new Error('"createHost" was called without a required field "applicationId"');
  }
  return {
    // environment: {},
    channel: (0, _channel.createWebsiteChannel)({
      clientSdk,
      applicationId
    }),
    close: () => {}
  };
};
exports.createHost = createHost;
//# sourceMappingURL=hostPlatform.js.map